import { Client, Project, Task, Transaction, Supplier, Expense, FinancialCategory, SubscriptionPlan, Subscription, SubscriptionInvoice } from './types';

export const mapClient = (data: any): Client => ({
  id: data.id,
  name: data.name,
  tradingName: data.trading_name,
  type: data.type,
  contactName: data.contact_name,
  contactRole: data.contact_role,
  email: data.email,
  billingEmail: data.billing_email,
  phone: data.phone,
  cnpj: data.cnpj,
  stateRegistration: data.state_registration,
  address: data.address,
  website: data.website,
  notes: data.notes,
  avatarUrl: data.avatar_url,
  logoUrl: data.logo_url,
  status: data.status,
  activeProjectsCount: data.active_projects_count,
  briefing: data.briefing
});

export const mapProject = (data: any): Project => ({
  id: data.id,
  name: data.name,
  client: data.client,
  deadline: data.deadline,
  status: data.status,
  completion: data.completion
});

export const mapTask = (data: any): Task => ({
  id: data.id,
  name: data.name,
  description: data.description,
  status: data.status,
  tag: data.tag,
  assigneeAvatar: data.assignee_avatar,
  progress: data.progress,
  checklist: data.checklist,
  checklistCount: data.checklist_count, // If exists in DB, otherwise undefined
  dueDate: data.due_date,
  projectId: data.project_id
});

export const mapTransaction = (data: any): Transaction => ({
  id: data.id,
  client: data.client,
  plan: data.plan,
  date: data.date,
  amount: data.amount,
  status: data.status,
  initials: data.initials,
  installmentGroupId: data.installment_group_id,
  installmentNumber: data.installment_number,
  totalInstallments: data.total_installments
});

export const mapSubscriptionPlan = (data: any): SubscriptionPlan => ({
  id: data.id,
  name: data.name,
  price: data.price,
  createdAt: data.created_at
});

export const mapSubscription = (data: any): Subscription => ({
  id: data.id,
  clientId: data.client_id,
  enabled: data.enabled,
  monthlyValue: data.monthly_value,
  dueDay: data.due_day,
  planId: data.plan_id,
  startDate: data.start_date,
  cancelDate: data.cancel_date,
  createdAt: data.created_at
});

export const mapSubscriptionInvoice = (data: any): SubscriptionInvoice => ({
  id: data.id,
  subscriptionId: data.subscription_id,
  clientId: data.client_id,
  periodRef: data.period_ref,
  issueDate: data.issue_date,
  dueDate: data.due_date,
  amount: data.amount,
  status: data.status,
  paidAt: data.paid_at,
  paidAmount: data.paid_amount,
  createdAt: data.created_at
});

export const mapSupplier = (data: any): Supplier => ({
  id: data.id,
  name: data.name,
  category: data.category,
  cnpj: data.cnpj,
  contactName: data.contact_name,
  email: data.email,
  phone: data.phone
});

export const mapExpense = (data: any): Expense => ({
  id: data.id,
  description: data.description,
  category: data.category,
  amount: data.amount,
  dueDate: data.due_date,
  status: data.status,
  supplierId: data.supplier_id,
  installmentGroupId: data.installment_group_id,
  installmentNumber: data.installment_number,
  totalInstallments: data.total_installments
});

export const mapFinancialCategory = (data: any): FinancialCategory => ({
  id: data.id,
  name: data.name,
  type: data.type,
  parent_id: data.parent_id
});
